import { default as FEATURES } from '../../../common/feature-enum';
import {
    NAVIGATION,
    routeToClaim,
    NAVIGATION_SORTED
} from '../../../common/navigation-enums';

class Navigation {
    constructor(
        $sce,
        $state,
        $window,
        $timeout,
        $rootScope,
        $templateCache,
        AuthorizationService
    ) {
        this.$sce = $sce;
        this.$state = $state;
        this.$window = $window;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.$templateCache = $templateCache;
        this.AuthorizationService = AuthorizationService;

        this.link = this.NavigationLink;
        this.template = this.getTemplate;
    }

    get getTemplate() {
        const template = this.$templateCache.get(
            'nav-bar/main-site/navigation.html'
        );
        return template;
    }

    generateNavLinks() {
        const navigationRoutes = Object.keys(NAVIGATION).map(
            option => NAVIGATION[option]
        );
        this.allowedRoutes = navigationRoutes.map(route => {
            const claim = routeToClaim(route);
            const { order, description } = claim;

            const mappedRoute = {
                order,
                description,
                value: route
            };

            return mappedRoute;
        });
        const sortedNavigation = NAVIGATION_SORTED(this.allowedRoutes);

        return sortedNavigation;
    }

    init(scope, element, attrs) {
        scope.activeLink = null;
        this.$element = element;
        this.scopeReference = scope;
        const routes = this.generateNavLinks();
        scope.routes = routes;
        this.scopeReference.$element = angular.element(element);
        this.scopeReference.toggleDashboardList = this.toggleDashboardList;
        this.$timeout(() => {
            this._registerEventHandling();
        });
    }

    toggleDashboardList() {
        const $arrow = angular.element('i.fas', this.$element);
        const $dashboardList = angular.element('#propertyMenu', this.$element);

        if ($dashboardList && $dashboardList.length > 0) {
            const isShowing = $dashboardList.hasClass('in');

            if (isShowing) {
                $arrow.addClass('fa-chevron-down');
                $arrow.removeClass('fa-chevron-up');
            } else {
                $arrow.addClass('fa-chevron-up');
                $arrow.removeClass('fa-chevron-down');
            }
        }
    }

    _setSelectPage($links, incomingPage = undefined) {
        let navigationPage;
        const currentPage = incomingPage || this.scopeReference.MainVM.currentPage;
        if (!!currentPage) {
            switch (currentPage) {
                case '':
                case '/':
                case FEATURES.DASHBOARD:
                    navigationPage = NAVIGATION.PropertyList;
                    break;
                case FEATURES.TENANT:
                    navigationPage = NAVIGATION.ManageTents;
                    break;
                case FEATURES.DOCUMENTS:
                    navigationPage = NAVIGATION.BuildingDocuments;
                    break;
                case FEATURES.COMPLIANCE:
                    navigationPage = NAVIGATION.Compliance;
                    break;
                case FEATURES.ACCOUNT_HISTORY:
                    navigationPage = NAVIGATION.AccountHistory;
                    break;
                case FEATURES.FINANCIAL_SUMMARY:
                    navigationPage = NAVIGATION.FinancialPack;
                    break;
                case FEATURES.PAYMENTS:
                    navigationPage = NAVIGATION.PaymentApprovals;
                    break;
                case FEATURES.PAYMENT_AUTHORISATION:
                    navigationPage = NAVIGATION.PaymentAuthorisation;
                    break;
                case FEATURES.PERSONAL_DOCUMENTS:
                    navigationPage = NAVIGATION.PersonalDocuments;
                    break;
                case FEATURES.DOCUMENTS_APPROVAL:
                    navigationPage = NAVIGATION.DocumentsApproval;
                    break;
                case FEATURES.SHOW_FIND_A_CONTRACTOR:
                    navigationPage = NAVIGATION.ShowFindAContractor;
                    break;
                case FEATURES.AUDITORS_DASHBOARD:
                    navigationPage = NAVIGATION.AuditorsDashboard;
                    break;
            }

            const link = $links.toArray().find(l => {
                const $l = angular.element(l);
                const found = $l.text() === navigationPage;
                return found;
            });

            if (link) {
                $links.each((i, l) => {
                    const $l = angular.element(l);
                    $l.removeClass('active');
                });
                angular.element(link).addClass('active');
            }
        }
    }

    _registerEventHandling() {
        const $links = angular.element('li.nav-list-item', this.$element);

        this._setSelectPage($links);

        $links.each((i, link) => {
            const $link = angular.element(link);
            $link.on('click', evt => {
                const { currentTarget } = evt;
                const $target = angular.element(currentTarget);
                const value = $target.text();

                $links.each((i, l) => {
                    const $l = angular.element(l);
                    $l.removeClass('active');
                });

                switch (value) {
                    case NAVIGATION.ManageTents:
                        this.$rootScope.$broadcast('navigate-changed', FEATURES.TENANT);
                        break;
                    case NAVIGATION.PaymentApprovals:
                        this.$rootScope.$broadcast('navigate-changed', FEATURES.PAYMENTS);
                        break;
                    case NAVIGATION.BuildingDocuments:
                        this.$rootScope.$broadcast('navigate-changed', FEATURES.DOCUMENTS);
                        break;
                    case NAVIGATION.PropertyList:
                        this.$rootScope.$broadcast('navigate-changed', FEATURES.DASHBOARD);
                        break;
                    case NAVIGATION.MyProfile:
                        this.$rootScope.$broadcast('navigate-changed', FEATURES.MY_PROFILE);
                        break;
                    case NAVIGATION.Utility:
                        this.$rootScope.$broadcast('navigate-changed', FEATURES.UTILITY);
                        break;
                    case NAVIGATION.Compliance:
                        this.$rootScope.$broadcast('navigate-changed', FEATURES.COMPLIANCE);
                        break;
                    case NAVIGATION.FinancialPack:
                        this.$rootScope.$broadcast('navigate-changed', FEATURES.FINANCIAL_SUMMARY);
                        break;
                    case NAVIGATION.AccountHistory:
                        this.$rootScope.$broadcast('navigate-changed', FEATURES.ACCOUNT_HISTORY);
                        break;
                    case NAVIGATION.PersonalDocuments:
                        this.$rootScope.$broadcast('navigate-changed', FEATURES.PERSONAL_DOCUMENTS);
                        break;
                    case NAVIGATION.PaymentAuthorisation:
                        this.$rootScope.$broadcast('navigate-changed', FEATURES.PAYMENT_AUTHORISATION);
                        break;
                    case NAVIGATION.DocumentsApproval:
                        this.$rootScope.$broadcast('navigate-changed', FEATURES.DOCUMENTS_APPROVAL);
                        break;
                    case NAVIGATION.ShowFindAContractor:
                        this.$rootScope.$broadcast('navigate-changed', FEATURES.SHOW_FIND_A_CONTRACTOR);
                        break;
                    case NAVIGATION.AuditorsDashboard:
                        this.$rootScope.$broadcast('navigate-changed', FEATURES.AUDITORS_DASHBOARD);
                        break;
                }

                $target.addClass('active');
            });
        });

        this.scopeReference.$on('selected-building-changed', ({ path: page }, schemeRef) => {
            this._setSelectPage($links, page);
        });

        this.scopeReference.$on(
            'client-navigation-changed',
            ($event, { path: page }) => {
                this._setSelectPage($links, page);
                this.generateNavLinks();
            }
        );
    }

    NavigationLink(scope, elements, attrs) {
        this.init(scope, elements, attrs);
    }
}

export default /* @ngInject */ (
    $sce,
    $state,
    $window,
    $timeout,
    $rootScope,
    $templateCache,
    AuthorizationService
) =>
    new Navigation(
        $sce,
        $state,
        $window,
        $timeout,
        $rootScope,
        $templateCache,
        AuthorizationService
    );
